export enum MessagingTemplateTypes {
    PIN_EMAIL = "pin-email",
    PIN_SMS = "pin-sms",
    DCUI_EMAIL = "dcui-email",
    DCUI_SMS = "dcui-sms"
}